module.exports = __webpack_public_path__ + "20745f4f75bab57e593c5586cd154a15.png";